import cls from "classnames";
import { ChangeEventHandler, FocusEventHandler, ReactNode } from "react";

import ElementWithIcons from "./../formElements/ElementWithIcons";
import arrowImg from "images/down-arrow.svg";
import greyArrowImg from "images/down-arrow-grey.svg";

import "./../common.css";

type Props = {
  name?: string;
  id?: string;
  // Callers reset this to null to clear the selection; React leaves the rendered
  // option alone in that case, so state and the visible choice can disagree.
  value?: string | number | null;
  onChange?: ChangeEventHandler<HTMLSelectElement>;
  onBlur?: FocusEventHandler<HTMLSelectElement>;
  className?: string;
  leftImage?: string;
  disabled?: boolean;
  width?: string;
  backgroundSize?: string;
  children?: ReactNode;
};

export default function Dropdown(props: Props) {
  return (
    <ElementWithIcons
      type="select"
      name={props.name}
      id={props.id}
      onChange={props.onChange}
      onBlur={props.onBlur}
      value={props.value}
      className={cls("app-select", props.className)}
      leftImage={props.leftImage}
      rightImage={props.disabled ? greyArrowImg : arrowImg}
      disabled={props.disabled}
      width={props.width}
      backgroundSize={props.backgroundSize}
    >
      {props.children}
    </ElementWithIcons>
  );
}
